.root {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: var(--aura-space-3);
  padding: var(--aura-space-3) var(--aura-space-4);
  color: rgba(var(--glass-color-black) / var(--glass-opacity-95));
  background: color-mix(
    in srgb,
    var(--aura-color-glass-surface) 88%,
    rgba(var(--glass-color-black) / var(--glass-opacity-20))
  );
  border-block: 1px solid
    color-mix(in srgb, var(--aura-color-global-border-soft) 58%, transparent);
  text-shadow: 0 1px 0 var(--glass-border-hover);
  transition: opacity var(--aura-motion-duration-normal)
    var(--aura-motion-easing-standard);
  pointer-events: auto;
  box-sizing: border-box;
  min-width: 0;
  min-height: 64px;
}

.positionTop {
  top: 0;
  border-radius: 0 0 var(--aura-radius-lg) var(--aura-radius-lg);
}

.positionBottom {
  bottom: 0;
  border-radius: var(--aura-radius-lg) var(--aura-radius-lg) 0 0;
}

.positionBelow {
  position: relative;
  margin-top: var(--aura-space-3);
  border-radius: var(--aura-radius-lg);
}

.glass {
  background: var(--glass-neutral-level2-surface);
  border: 1px solid var(--aura-color-glass-border);
  backdrop-filter: blur(var(--aura-glass-neutral-level2-backdrop-blur))
    var(--glass-filter-base);
  -webkit-backdrop-filter: blur(var(--aura-glass-neutral-level2-backdrop-blur))
    var(--glass-filter-base);
  box-shadow: var(--aura-color-glass-shadow);
}

.actionLeft {
  flex-direction: row-reverse;
}

.titleWrapper {
  flex: 1;
  min-width: 0;
}

.title {
  font-size: 0.875rem;
  font-weight: var(--aura-font-weight-medium);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgba(var(--glass-color-black) / var(--glass-opacity-95));
}

.subtitle {
  margin-top: var(--glass-space-image-item-bar-subtitle, 2px);
  font-size: 0.75rem;
  line-height: 1.2;
  opacity: 1;
  color: rgba(var(--glass-color-black) / var(--glass-opacity-75));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--aura-space-3);
}

.actionLeftAction {
  margin-left: 0;
  margin-right: var(--aura-space-3);
}

.showOnHover {
  opacity: 0;
  pointer-events: none;
}

.visible {
  opacity: 1;
  pointer-events: auto;
}

.noTransition {
  transition: none;
}

@media (prefers-reduced-motion: reduce) {
  .root {
    transition: none;
  }
}
